import ReactDOM from 'react-dom/client';
import App from './App'


import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PublicClientApplication, EventType  } from "@azure/msal-browser";
import { getMsalConfig, popupRequest } from './auth/authConfig';
import { loadRuntimeConfig } from './utilities/runtimeConfig';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import { FormLayout, HeaderContainerDiv } from './components/styledComponents/Components.styles'
import { CommonButton } from './components/styledComponents/MUI.styles';
import { sanitizePublicUrl } from './utilities/utilityFunctions';
// Ford logo lives in /public so we reference it via PUBLIC_URL instead of importing (CRA restriction)
const FORD_LOGO_URL = `${sanitizePublicUrl(process.env.PUBLIC_URL)}/ford_oval_blue.svg`;

async function bootstrap() {
    const runtimeConfig = await loadRuntimeConfig();
    console.info(
        `[RuntimeConfig] Environment=${runtimeConfig.environment}, API=${runtimeConfig.apiBaseUrl}, UI=${runtimeConfig.uiBaseUrl}`
    );
    const msalInstance = new PublicClientApplication(getMsalConfig());
    await msalInstance.initialize();

    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Listen for sign-in event and set active account
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            const account = event.payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
      // <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <ErrorBoundary>
            <FormLayout >
                <AuthenticatedTemplate>
                    <App />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                   {/* <MainHeaderLabel style={{fontFamily: 'FordF-1-Semibold', fontSize: '30px'}}>SRP Software Release</MainHeaderLabel> */}
                    <HeaderContainerDiv style={{fontFamily: 'FordF-1-Semibold', fontSize: '30px', display:'flex', alignItems:'center', height: '15vh'}}>
                        <span style={{display:'flex', alignItems:'center', gap:'12px'}}>
                            <img src={FORD_LOGO_URL} alt="Ford Logo" style={{height:'48px'}} />
                            <span>SRP Software Release</span>
                        </span>
        
                    </HeaderContainerDiv>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20vh', height: 'calc(100% - 15vh)', justifyContent: 'center'}}>

                        <span style={{marginTop:'30px', marginBottom:'10px', fontSize: '25px'}}>Welcome to the Software Release Portal</span>
                        <br/>

                    <CommonButton onClick={() => msalInstance.loginPopup(popupRequest)}>Sign In</CommonButton>
                    </div>
                </UnauthenticatedTemplate>
            </FormLayout>
        </ErrorBoundary>
      </MsalProvider>
      // </React.StrictMode>
    );
}

bootstrap();